export * from '@fhs/routing/src/routes/receipt/_layout';
export { default } from '@fhs/routing/src/routes/receipt/_layout';
